// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__17MJL","modalFooterButton":"ModalNotes_modalFooterButton__2mAfX"};